import React, { useEffect } from 'react';
import { useEnvironment } from '@wix/yoshi-flow-editor';
import loadable from '@wix/yoshi-flow-editor/loadable';
import { CustomDialog } from '@wix/wix-ui-tpa/cssVars';

import { useSidebarLayoutBase } from '../contexts/SidebarLayoutBase/SidebarLayoutBaseContext';
import { classes } from '../SidebarLayoutForParticipant.st.css';

const AiChat = loadable(() => {
  return import(/* webpackPrefetch: true */ './AIChat/AIChat');
});

function AiChatDialog() {
  const { isAiChatEnabled, toggleAiChatVisibility, isAiChatVisible } =
    useSidebarLayoutBase();
  const { isMobile } = useEnvironment();

  useEffect(() => {
    if (!isMobile) {
      return;
    }

    if (isAiChatVisible) {
      document.body.style.overflow = 'hidden';
    }

    return () => {
      document.body.style.overflow = '';
    };
  }, [isAiChatVisible, isMobile]);

  if (!isAiChatEnabled || !isMobile) {
    return null;
  }

  return (
    <CustomDialog
      isOpen={isAiChatVisible}
      onClose={() => toggleAiChatVisibility()}
    >
      <div className={classes.aiChatDialog}>
        <div className={classes.aiChatContent}>
          <AiChat />
        </div>
      </div>
    </CustomDialog>
  );
}

export default AiChatDialog;
